import { fetcher } from '@commenda/utils';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import type { InvoiceDownloadResponse, InvoiceRequest } from './types';

export async function downloadInvoice(
  request: Readonly<InvoiceRequest>
): Promise<InvoiceDownloadResponse> {
  const res = await fetcher(
    BillingInvoiceHelper.invoiceUrl(request, 'download'),
    {
      method: 'GET',
    }
  );
  if (!res.ok) throw new Error('Could not download the invoice.');
  const result: unknown = await res.json();
  if (
    !result ||
    typeof result !== 'object' ||
    !('downloadUrl' in result) ||
    typeof result.downloadUrl !== 'string' ||
    !result.downloadUrl
  ) {
    throw new Error('The invoice PDF is not available yet.');
  }
  return { downloadUrl: result.downloadUrl };
}
